import { render, staticRenderFns } from "./payerReportDetails.vue?vue&type=template&id=64cae948&scoped=true"
import script from "./payerReportDetails.vue?vue&type=script&lang=js"
export * from "./payerReportDetails.vue?vue&type=script&lang=js"
import style0 from "./payerReportDetails.vue?vue&type=style&index=0&id=64cae948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cae948",
  null
  
)

export default component.exports